var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.$store.getters.isExecutingRequest
      ? _c("div", { staticClass: "row mb-3" }, [
          _c("div", { staticClass: "col-md-9" }, [
            _c(
              "div",
              { staticClass: "vjs-responsive" },
              [
                _c("video-player", {
                  ref: "videoPlayer",
                  staticClass: "vjs-custom-skin",
                  attrs: { options: _vm.playerOptions },
                  on: {
                    timeupdate: function($event) {
                      return _vm.onPlayerTimeupdate($event)
                    },
                    ready: _vm.playerReadied,
                    pause: _vm.updateViewProgress
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3 stretch-card" }, [
            _c("div", { staticClass: "card shadow-sm" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h4", { staticClass: "text-primary oswald" }, [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.$t("pages.admin.video.upload.focuses_on")) +
                      "\n                        "
                  )
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "ul",
                  _vm._l(_vm.video.goals, function(item) {
                    return _c("li", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(item.label[_vm.$i18n.locale]) +
                          "\n                            "
                      )
                    ])
                  }),
                  0
                )
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card shadow-sm" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("static-loading-indicator-icon"),
              _vm._v(" "),
              !_vm.$store.getters.isExecutingRequest
                ? _c("div", [
                    _vm.video
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-9" },
                            [
                              _c("h5", { staticClass: "card-title" }, [
                                _c("span", { staticClass: "oswald" }, [
                                  _vm._v(_vm._s(_vm.videoTitle))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("gym-video-level-badge", {
                                attrs: {
                                  level: _vm.video.level,
                                  label: _vm.video.localized_level
                                }
                              }),
                              _vm._v(" "),
                              _c("gym-video-intensity-badge", {
                                attrs: { intensity: _vm.video.intensity }
                              }),
                              _vm._v(" "),
                              _c("gym-video-duration-badge", {
                                attrs: { duration: _vm.video.duration }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-3 text-right" }, [
                            _c("i", {
                              staticClass: "mdi mdi-36px",
                              class: [
                                _vm.watchedEntirely
                                  ? "mdi-check-decagram text-primary"
                                  : ""
                              ]
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "mdi mdi-36px cursor-pointer",
                              class: [
                                _vm.isVideoFavored
                                  ? "mdi-heart text-primary"
                                  : "mdi-heart-outline text-muted",
                                _vm.favButtonHovered ? "text-primary" : ""
                              ],
                              on: {
                                mouseenter: function($event) {
                                  _vm.favButtonHovered = true
                                },
                                mouseleave: function($event) {
                                  _vm.favButtonHovered = false
                                },
                                click: _vm.toggleFavorVideo
                              }
                            })
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("p", [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("pages.gym.equipment_needed")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-muted" }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.equipment) +
                          "\n                            "
                      )
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }